/** @format */
import React, { Fragment } from "react";
import { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import {
  AppBar,
  Collapse,
  List,
  ListItemButton,
  Popover,
  Toolbar,
  useTheme,
  Button,
  ListItemText,
} from "@mui/material";
import { Box } from "@mui/system";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import ExpandLess from "@mui/icons-material/ExpandLessRounded";
import ExpandMore from "@mui/icons-material/ExpandMoreRounded";
import ListItemIcon from "@mui/material/ListItemIcon";
import LenguageMenu from "./LanguageMenu";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import LogoP5Mobile from "../../img/Logo P5 Mobile.png";

const useStyles = (theme, isMobile) => ({
  container: {
    height: "4rem",
    boxShadow: "none",
    backgroundColor: theme.palette.white.secondary,
    color: theme.palette.blue.main,
    fontFamily: theme.typography.anaHeim.regular,
  },
  popOver: {
    fontFamily: theme.typography.montserrat.semibold,
    bg: theme.palette.white.main,
    color: theme.palette.blue.main,
  },
});

const mainMenu = [
  {
    to: "/",
    text: "Home",
  },
  {
    text: "Etapas",
    stages: [
      "/intro",
      "/challenge",
      "/bootcamp",
      "/bootcamp/javascript",
      "/bootcamp/salesforce",
    ],
    menu: [
      {
        to: "/intro",
        text: "1- Curso Introductorio",
      },
      {
        to: "/challenge",
        text: "2- Coding Challenge",
      },
      {
        text: "3- Coding Bootcamp",
        to: "/bootcamp",
        submenu: [
          {
            to: "/bootcamp/javascript",
            text: "JavaScript Bootcamp",
          },
          {
            to: "/bootcamp/salesforce",
            text: "Salesforce Bootcamp",
          },
        ],
      },
    ],
  },
  {
    to: "/nosotros",
    text: "Nosotros",
  },
  {
    to: "/faqs",
    text: "Preguntas Frecuentes",
  },
];

const NavBarMobile = () => {
  const theme = useTheme();

  const classes = useStyles(theme);

  const [openMenu, setOpenMenu] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(false);
  const [openBootsMenu, setOpenBootsMenu] = useState(false);
  const anchorEl = useRef();
  const tab = "\u00A0";

  const location = useLocation();
  const { pathname } = location;

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleOpenSubmenu = () => {
    setOpenSubMenu(!openSubMenu);
  };

  const handleOpenBoots = () => {
    setOpenBootsMenu(!openBootsMenu);
  };

  useEffect(() => {
    setOpenMenu(false);
    setOpenSubMenu(false);
  }, [pathname]);

  return (
    <>
      <AppBar
        component="nav"
        position="static"
        sx={classes.container}
        ref={anchorEl}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            textAlign: "center",
            zIndex: 1,
          }}
        >
          <Box component={Link} to={"/"}>
            <img
              src={LogoP5Mobile}
              alt="Plataforma 5 Logo"
              title="Plataforma 5 Logo"
              style={{
                padding: "2rem",
                height: "2.5rem",
                alignItems: "center",
              }}
            />
          </Box>
          <List>
            <ListItemButton onClick={handleOpenMenu}>
              <MenuRoundedIcon
                style={{
                  color: theme.palette.blue.main,
                }}
              />
            </ListItemButton>
          </List>
        </Toolbar>
      </AppBar>

      <Popover
        id="Id"
        open={openMenu}
        anchorEl={anchorEl.current}
        sx={{
          boxShadow: "none",
        }}
        onClose={handleOpenMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            width: "100%",
            boxShadow: "none",
            ml: "-16px",
            maxWidth: "100%",
            backgroundColor: theme.palette.white.secondary,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 25,
            borderBottomRightRadius: 25,
          },
        }}
      >
        <List sx={{ color: theme.palette.blue.main }}>
          {mainMenu.map(({ to, text, menu, stages }) => (
            <Fragment key={uuidv4()}>
              <ListItemButton
                to={to}
                onClick={!to ? handleOpenSubmenu : null}
                sx={{
                  ...classes.popOverList,
                  fontFamily: theme.typography.montserrat.semibold,
                  width: "90%",
                  margin: "1rem",
                  fontSize: "1rem",
                  bgcolor:
                    (pathname === to || stages?.includes(pathname)) &&
                    theme.palette.blue.secondary,
                  color:
                    (pathname === to || stages?.includes(pathname)) &&
                    theme.palette.white.main,
                }}
              >
                {text}
                {!to ? openSubMenu ? <ExpandLess /> : <ExpandMore /> : null}
              </ListItemButton>

              {menu ? (
                <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
                  <List sx={{ ml: 3 }}>
                    {menu.map(({ to, text, submenu }) => (
                      <Fragment key={uuidv4()}>
                        <ListItemButton
                          component={to ? Link : null}
                          to={to ? to : null}
                          onClick={!to ? handleOpenBoots : null}
                          sx={{
                            color: theme.palette.blue.main,
                            fontFamily: theme.typography.montserrat.semibold,
                            fontSize: "1rem",
                            margin: "1rem 0 0 0",
                          }}
                        >
                          {text}
                        </ListItemButton>

                        {submenu ? (
                          <List sx={{ ml: 2 }}>
                            {submenu.map(({ to, text }) => (
                              <ListItemButton
                                key={uuidv4()}
                                sx={{
                                  pl: 4,
                                  color: theme.palette.blue.main,
                                  fontFamily:
                                    theme.typography.montserrat.semibold,
                                  margin: "0rem",
                                }}
                                component={Link}
                                to={to}
                              >
                                <ListItemIcon style={{ minWidth: "2rem" }}>
                                  <ArrowForwardIosRoundedIcon
                                    style={{
                                      height: "1rem",
                                      color: theme.palette.blue.main,
                                    }}
                                  />
                                </ListItemIcon>
                                <ListItemText
                                  primary={text}
                                  sx={{
                                    color: theme.palette.blue.main,
                                    fontSize: ".5rem",
                                  }}
                                />
                              </ListItemButton>
                            ))}
                          </List>
                        ) : null}
                      </Fragment>
                    ))}
                  </List>
                </Collapse>
              ) : null}
            </Fragment>
          ))}

          <ListItemButton sx={classes.popOverList}>
            <Button
              component={Link}
              to={"/aplica"}
              sx={{
                margin: "0",
                padding: ".5rem 1.5rem .5rem 1.5rem",
                borderRadius: "25px",
                textTransform: "none",
                bgcolor: theme.palette.blue.secondary,
                color: theme.palette.white.main,
                alignText: "center",
              }}
              textalign="center"
            >
              Aplicar{tab}
              <span role="img" aria-label="Rocket">
                🚀
              </span>
            </Button>
          </ListItemButton>

          <LenguageMenu />
        </List>
      </Popover>
    </>
  );
};

export default NavBarMobile;
